import { render, staticRenderFns } from "./ClientFeedsTab.vue?vue&type=template&id=64b1997b"
import script from "./ClientFeedsTab.vue?vue&type=script&lang=js"
export * from "./ClientFeedsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports